import { ScrAuthorizationService } from '../../services/authorization.service';
import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ScrEnvironment } from '../../../environments/environment';

@Component({
  templateUrl: './styleguide.component.html',
  styleUrls: ['./styleguide.component.scss']
})
export class StyleGuideComponent {

  constructor(
    public env: ScrEnvironment,
    @Inject(DOCUMENT) private doc: Document
  ) {

  }
  public term = 0;
  public limit = 0;
  public model = {
    paymentType: '',
    lastName: ''
  };

  public date?: Date;
  public ddate?: Date;

  public termOptions = [
    { label: '3-Month', value: 3 },
    { label: '6-Month', value: 6 },
    { label: '12-Month', value: 12 },
  ];

  public ScrAuthorizationService = ScrAuthorizationService;

}
